<template>
  <div class="base-search">
    <icon-magnifier width="30"
                    height="30"
                    iconColor="#a8a7a7" />

    <input :placeholder="$t('search')"
           type="text"
           v-model="keyword"
           class="base-search-input"
           spellcheck="false" />
  </div>
</template>

<script>
  export default {
    data: () => ({
      keyword: ''
    }),

    created() {
      this.debouceOnInput = _.debounce(this.onInput, 500)
    },

    methods: {
      onInput() {
        this.$emit('search', this.keyword)
      }
    },

    watch: {
      keyword() {
        this.debouceOnInput()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .base-search {
    width: 100%;

    display: flex;
    align-items: center;

    border-bottom: 1px solid #e5e5e5;
    padding: 5px;

    &-input {
      width: 100%;
      font-size: 18px;
      color: #3e3a3b;

      margin-left: 12px;
      padding-top: 5px;
      border: none;

      &::placeholder {
        color: #a8a7a7;
      }
    }
  }
</style>